// @flow
export const LoginLocale = {
  form: {
    form_unit: {
      username: ["Email Address / Username for Platform", "Eposta Adresiniz / Platform Kullanıcı Adınız"],
      password: ["Password", "Parola"],
      submit: ["Login to Your Account", "Hesabınıza Giriş Yapın"]
    },
    register: {
      content: ["Don't have an Envanterium Platform account?  ", "Envanterium Platform hesabınız yok mu?  "],
      link: ["Continue to Request an Account.", "Hesap Talebine Devam Edin."]
    }
  },
  error: {
    header: [
        "An error occurred with your login.",
      "Sisteme girişinizi yaparken bir hatayla karşılaştık."
    ],
    content: [
      "There is a big chance that you submitted invalid information. Please try again.",
      "Yanlış bilgilerle giriş yapmaya çalıştınız. Lütfen bilgilerinizi kontrol edip tekrar deneyiniz."
    ],
    action: ["Return to Login Screen", "Giriş Yapma Ekranına Geri Dön"]
  },
  completed: {
    content: [
      "Please wait while we log you in to your account...",
      "Hesabınıza girişinizi gerçekleştirirken lütfen bekleyiniz..."
    ]
  }
};



// WEBPACK FOOTER //
// ./src/Locales/PublicAccountPages/Login.locale.js